import React from 'react';

interface Props {
  text: React.ReactNode;
  className?: string;
}

const Title = ({ text, className }: Props) => {
  return <h1 className={`imd-title  ${className ? className : ''}`}>{text}</h1>;
};

export default Title;
